<template>
  <div class="shopRating">
    <section class="detail_content">
    <div class="shop-rating">
         <h3 class="heading" v-if="getShopRating.shopName">Tell me about {{getShopRating.shopName}}</h3>
         <h3 class="heading" v-else-if="$route.query.shopName">Tell me about {{$route.query.shopName}}</h3>
         <h3 class="heading" v-else>Tell me about shop</h3>
         <ul class="option-list">
             <li @click="shopQuality = 'FAKE'"><h4>Shop is Fake</h4>
             <p>यह शॉप आपके एरिया में नहीं है और दूकानदार का भी कांटेक्ट करने पर कोई जवाब नहीं आता है</p>
            <span :class="shopQuality === 'FAKE' ? 'active' : ''"></span>
             </li>
             <li @click="shopQuality = 'REAL'"><h4>Shop is Real</h4>
             <p>यह शॉप आपके एरिया में है और आप इससे खरीदारी करते हैं - अपना रिव्यु दीजिए</p><span :class="shopQuality === 'REAL' ? 'active' : ''"></span></li>
         </ul>
     </div>
     <div class="mid-cnt">
      <div v-if="shopQuality === 'REAL'">
        <ul class="quality-option">
          <li
            v-for="(category,index) in rateFeatureReason"
            :key="index"            
            @click="selectValue(category.id)"
          >
            <span :class="{'active' : checkClass(category.id)}"></span><p>{{category.title}}</p>
          </li>
        </ul>
        <h3 class="small-heading">Please provide your valuable Rating and Comment</h3>
        <div class="total-rating">
        <star-rating
            @current-rating="setCurrentRating($event)"
            :starSize="30"
            :rating="Number(getShopRating.avgRating)"
            :show-rating="false"
            active-color="#138808"
          ></star-rating>
        </div>
      </div>
      <div v-else>
        <!-- <h3 class="small-heading">Please provide your valuable Rating and Comment</h3> -->
        <div class="total-rating">
        <star-rating
            :starSize="30"
            :read-only="true"
            :rating="Number(1)"
            :show-rating="false"
            active-color="#138808"
          ></star-rating>
        </div>
      </div>
    </div>
    <span class="submit-btn" @click="submitFeedBack()">SUBMIT</span>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <div id="cart-snackbar" :class="{'show': showError}">
      <div class="flx">
        <p style="text-align:center;width:100%">{{errorMessage}}</p>
      </div>
    </div>
    <div class="shop-rating-success" v-if="successDone">
      <div class="rating-success">
        <span class="success-logo">
            <img src="../assets/images/icons/check-mark-success.gif" />
        </span>
        <p class="thanks-text">Thanks for rating</p>
        <p class="info-message">Your rating submitted Successfully.</p>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
export default {
  name: "ShopRating",
  components: {
    StarRating
  },
 
  data() {
    return {
      loading: false,
      shopQuality: 'REAL',
      selected: [],
      rateFeatureReason: [],
      getShopRating: {
        rateFeatureReasonDTOs: this.selected,
        shopId: this.$route.params.shopid
      },
      nonSelectIdList: [],
      selectedCategory: {},
      showError: false,
      errorMessage: '',
      successDone: false
    };
  },
  methods: {
     checkClass(category){
      if(!this.selectedCategory.hasOwnProperty(category)) return false
      return this.selectedCategory[category];
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    selectValue(category) {
      if(!this.selectedCategory.hasOwnProperty(category))
        this.$set(this.selectedCategory, category, true);
      else 
        this.$set(this.selectedCategory, category, !this.selectedCategory[category]);
    },
    setCurrentRating(rating, id) {
      this.getShopRating.avgRating = rating
    },
    getRateFeatureReason(){
      ApiCaller(
        constant.SHOP_DETAIL_URL,
        `get-rate-feature-reasons`,
        "get"
      ).then((data) => {
        this.rateFeatureReason = data.data
      });
    },
    submitFeedBack(){
      let selectedIds = []
      if(this.shopQuality === 'REAL'){
      for(let i in this.selectedCategory)
        if(this.selectedCategory[i])
         selectedIds.push(i)
      if(!selectedIds.length){
        this.showError = !this.showError
        setTimeout(()=> {
          this.showError = !this.showError;        
        }, 3000);
        this.errorMessage = 'Please select one or more options. Your feedback is valuable to us.'
      return;
      }else if(!this.getShopRating.avgRating){
        this.showError = !this.showError
        setTimeout(()=> {
          this.showError = !this.showError;        
        }, 3000);
        this.errorMessage = 'Please provide ratings for the shop.'
        return
      }
      }
      this.loading = true
      
      const obj = {
        shopId: this.$route.params.shopid,
        shopReview: this.shopQuality,
        avgRating: this.getShopRating.avgRating,
        rateFeatureReasonDTOs:selectedIds
      }
      if(this.shopQuality ==='FAKE'){
        obj.rateFeatureReasonDTOs = [7]
        obj.avgRating = Number(1)
      }
      ApiCaller(
        constant.SHOP_DETAIL_URL,
        `add-shop-rating-by-user`,
        "post",
        obj
      ).then((data) => {
        this.loading = false
        this.successDone = !this.successDone
        setTimeout(()=> { 
          this.$router.go(-1)       
        }, 2000);
        
      }).catch(err =>{
        console.log(err)
        this.loading = false
      })
    },
    getShopFeedback(){
      this.loading = true
      ApiCaller(
        constant.SHOP_DETAIL_URL,
        `get-shop-rating/${this.$route.params.shopid}`,
        "get"
      ).then((data) => {
        this.loading = false
        this.getShopRating = data.data
        this.selected = [];
        this.getShopRating.rateFeatureReasonDTOs.map((it) => {
          this.$set(this.selectedCategory, it.id, true)
        });
        if(this.getShopRating.shopReview){
          this.shopQuality = this.getShopRating.shopReview
        }else{
          this.shopQuality = 'REAL'
        }
        
      }).catch(err =>{
        console.log(err)
        this.loading = false
      })
    }
  },
  mounted() {
    this.getRateFeatureReason()
    this.getShopFeedback()
  },
};
</script>
<style lang="scss" scoped>
.submit-btn{
      display: block;
    background-color: green;
    font-size: 1.125em;
    padding: 10px;
    font-weight: 600;
    border-radius: 4px;
    color: white;
    text-align: center;
    margin-top: 24px;
    position: fixed;
    bottom: 8px;
    width: calc(100% - 100px);
        left: 50px;
}
.shop-rating-success{
  background: #0000007a;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}
.rating-success{
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    background: #fff;
    padding: 16px;
    text-align: center;
    box-shadow: 0 0px 6px 0 rgb(0 0 0 / 16%);
    width: 60%;
    border-radius: 8px;
    .success-logo{
        width: 60px;
        height: 60px;
        display: block;
        margin: 0 auto;
        img{
            max-width: 100%;
            max-height: 100%;
        }
    }
  .thanks-text{
        font-size: 1.05em;
        margin: 16px 0;
        font-weight: 600;
        color: green;
    }
    .info-message{
        font-size: 0.875em;
    }
}
</style>